module.exports = __webpack_public_path__ + "img/sewingTime.a5922766.svg";